import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api, formatApiError, TOKEN_KEY } from "@/lib/api";

const field = "w-full rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-white placeholder:text-zinc-500 outline-none focus:border-white/40 transition-colors";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      onLogin(data.user);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-5">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm rounded-[28px] border border-white/10 bg-[#111113] p-8">
        <img src="/brand/logo-white.png" alt="RC iPhones" className="mx-auto h-20 w-auto" />
        <p className="mono mt-8 text-center text-[11px] uppercase tracking-[0.28em] text-zinc-400">Área do lojista</p>
        <div className="mt-6 space-y-3">
          <input data-testid="admin-email-input" type="email" required placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
          <input data-testid="admin-password-input" type="password" required placeholder="Senha" value={password} onChange={(e) => setPassword(e.target.value)} className={field} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-400">{error}</p>}
        <button data-testid="admin-login-button" disabled={busy} className="mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-white py-3 font-semibold text-black transition-transform hover:scale-[1.02] active:scale-95 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Entrar
        </button>
        <Link data-testid="admin-back-to-site" to="/" className="mt-5 block text-center text-sm text-zinc-400 hover:text-white">← Voltar ao site</Link>
      </form>
    </div>
  );
};
